// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-section{
    display: flex;
    height: 100vh;
    width: 100%;
    background-color: var(--background-color);
    overflow: hidden;
}


/* Start Header */

nav{
    padding-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
}

nav .men-btn {
    display: none;
}

@media(max-width:600px){
    nav{
        justify-content:start;
        
    }
    nav .men-btn {
        display: block;
        background-color: transparent;
        border: none;
        margin-right:  13px;
    }

    nav .men-btn svg{
        font-size: 20px;
    }
}

nav .user-component{
    display: flex;
    align-items: center;
    
}



nav .user-component .image{
    width: 50px;
    height: 50px;
}
nav .user-component .image img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

nav .user-component .info{
    margin: 0px 10px;
    
}
nav .user-component .info h2{
    font-size: 18px;
}

nav .user-component .info .date-join{
font-size: 14px;
color: #717171;
margin-top: -6px;
position: relative;
}

nav .user-component .info .date-join svg{
    font-size: 12px;
}

nav .menu-trigger .con{
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;

}

nav .menu-trigger .con p{
    margin:0px 7px;
    font-weight: 600;
}

nav .menu-trigger{
    position: relative;
}

nav .menu-trigger .menu-language{
    position: absolute;
    z-index: 1000;
    width: 160px;
    list-style: none;
    padding: 5px 7px;
    background-color: white;
    /* max-width: 100%; */
    border-radius: 7px;
    right: 0;
    top:120% ;
    border: 1px solid #EEE;
}

nav .menu-trigger .active-ar{
    right:-100%;
}

nav .menu-trigger .active{
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    transition: var(--main-transition) ease;
}

nav .menu-trigger .inactive {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
    transition: var(--main-transition) ease;
}

nav .menu-trigger .menu-language li{
    margin-bottom: 4px;
    transition: var(--main-transition);
    padding: 5px 4px;
    border-radius: 3px;
    cursor: pointer;
}

nav .menu-trigger .menu-language li:hover{
    background-color: #EEE;
    padding: 5px 6px;
}

/* End Header */



/* Start Search Page List */

.search-page-container{
    width: 100%;
    height: calc(100vh - 90px);
    overflow-y: scroll;
    padding-top: 20px;
}

.search-page-container .search-item-card{
    width: 600px;
    max-width: 100%;
    background-color: white;
    border-radius: 8px;
    margin-bottom: 15px;
    height: 157px;
    padding: 12px 12px;

}

.search-page-container .search-item-card .search-item-head{
    display: flex;
    align-items: center;

}

.search-page-container .search-item-card .search-item-head img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin: 0 6px;
}

.search-page-container .search-item-card .search-item-head h2{
    font-size: 17px;
}

.search-page-container .search-item-card .loc-con{
    margin-top: 10px;
}

.search-page-container .search-item-card .loc-con svg{
    color: var(--gray-color);
    font-size: 16px;
    margin: 0px 3px;
}

.search-page-container .search-item-card .loc-con p{
    color: var(--gray-color);
}

.search-page-container .search-item-card .get-post-btn{
    width: 100%;
    background-color: var(--main-color);
    color: white;
    font-weight: 600;
    cursor: pointer;
    border-radius: 7px;
    padding: 8px 0px;
    border: none;
    margin-top: 10px;
}

/* End Search Page List */

`, "",{"version":3,"sources":["webpack://./src/Components/Utils/utils.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,yCAAyC;IACzC,gBAAgB;AACpB;;;AAGA,iBAAiB;;AAEjB;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;AAElC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB;;IAEzB;IACA;QACI,cAAc;QACd,6BAA6B;QAC7B,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;;;AAIA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;;AAEpB;AACA;IACI,eAAe;AACnB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,eAAe;;;;AAIf,2BAA2B;;AAE3B;IACI,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,yBAAyB","sourcesContent":[".main-section{\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    background-color: var(--background-color);\n    overflow: hidden;\n}\n\n\n/* Start Header */\n\nnav{\n    padding-top: 20px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    \n}\n\nnav .men-btn {\n    display: none;\n}\n\n@media(max-width:600px){\n    nav{\n        justify-content:start;\n        \n    }\n    nav .men-btn {\n        display: block;\n        background-color: transparent;\n        border: none;\n        margin-right:  13px;\n    }\n\n    nav .men-btn svg{\n        font-size: 20px;\n    }\n}\n\nnav .user-component{\n    display: flex;\n    align-items: center;\n    \n}\n\n\n\nnav .user-component .image{\n    width: 50px;\n    height: 50px;\n}\nnav .user-component .image img{\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n}\n\nnav .user-component .info{\n    margin: 0px 10px;\n    \n}\nnav .user-component .info h2{\n    font-size: 18px;\n}\n\nnav .user-component .info .date-join{\nfont-size: 14px;\ncolor: #717171;\nmargin-top: -6px;\nposition: relative;\n}\n\nnav .user-component .info .date-join svg{\n    font-size: 12px;\n}\n\nnav .menu-trigger .con{\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n}\n\nnav .menu-trigger .con p{\n    margin:0px 7px;\n    font-weight: 600;\n}\n\nnav .menu-trigger{\n    position: relative;\n}\n\nnav .menu-trigger .menu-language{\n    position: absolute;\n    z-index: 1000;\n    width: 160px;\n    list-style: none;\n    padding: 5px 7px;\n    background-color: white;\n    /* max-width: 100%; */\n    border-radius: 7px;\n    right: 0;\n    top:120% ;\n    border: 1px solid #EEE;\n}\n\nnav .menu-trigger .active-ar{\n    right:-100%;\n}\n\nnav .menu-trigger .active{\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n    transition: var(--main-transition) ease;\n}\n\nnav .menu-trigger .inactive {\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-20px);\n    transition: var(--main-transition) ease;\n}\n\nnav .menu-trigger .menu-language li{\n    margin-bottom: 4px;\n    transition: var(--main-transition);\n    padding: 5px 4px;\n    border-radius: 3px;\n    cursor: pointer;\n}\n\nnav .menu-trigger .menu-language li:hover{\n    background-color: #EEE;\n    padding: 5px 6px;\n}\n\n/* End Header */\n\n\n\n/* Start Search Page List */\n\n.search-page-container{\n    width: 100%;\n    height: calc(100vh - 90px);\n    overflow-y: scroll;\n    padding-top: 20px;\n}\n\n.search-page-container .search-item-card{\n    width: 600px;\n    max-width: 100%;\n    background-color: white;\n    border-radius: 8px;\n    margin-bottom: 15px;\n    height: 157px;\n    padding: 12px 12px;\n\n}\n\n.search-page-container .search-item-card .search-item-head{\n    display: flex;\n    align-items: center;\n\n}\n\n.search-page-container .search-item-card .search-item-head img {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    margin: 0 6px;\n}\n\n.search-page-container .search-item-card .search-item-head h2{\n    font-size: 17px;\n}\n\n.search-page-container .search-item-card .loc-con{\n    margin-top: 10px;\n}\n\n.search-page-container .search-item-card .loc-con svg{\n    color: var(--gray-color);\n    font-size: 16px;\n    margin: 0px 3px;\n}\n\n.search-page-container .search-item-card .loc-con p{\n    color: var(--gray-color);\n}\n\n.search-page-container .search-item-card .get-post-btn{\n    width: 100%;\n    background-color: var(--main-color);\n    color: white;\n    font-weight: 600;\n    cursor: pointer;\n    border-radius: 7px;\n    padding: 8px 0px;\n    border: none;\n    margin-top: 10px;\n}\n\n/* End Search Page List */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
